var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo } from "react";
import { I18nextProvider } from "react-i18next";
import { ConfigProvider } from "../hooks/useConfig";
import i18n from "../strings/i18n";
import AccountDetailsModal from "./AccountDetailsModal/AccountDetailsModal";
import MainContext from "./Context";
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary";
var Providers = function (_a) {
    var children = _a.children, config = _a.config, triggerAnalyticsEvent = _a.triggerAnalyticsEvent, featureFlags = _a.featureFlags, isRegistered = _a.isRegistered, helpNumber = _a.helpNumber, selectedAccountId = _a.selectedAccountId;
    var mainContextValue = useMemo(function () { return ({
        featureFlags: featureFlags,
        isRegistered: isRegistered,
        helpNumber: helpNumber,
        selectedAccountId: selectedAccountId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
    }); }, [
        featureFlags,
        isRegistered,
        helpNumber,
        selectedAccountId,
        triggerAnalyticsEvent,
    ]);
    return (_jsx(MainContext.Provider, __assign({ value: mainContextValue }, { children: _jsx(ErrorBoundary, { children: _jsx(ConfigProvider, __assign({ value: config }, { children: children })) }) })));
};
export var AccountDetailsRoot = function (_a) {
    var config = _a.config, containerId = _a.containerId, featureFlags = _a.featureFlags, handleClose = _a.handleClose, isModalOpen = _a.isModalOpen, isRegistered = _a.isRegistered, helpNumber = _a.helpNumber, selectedAccountId = _a.selectedAccountId, triggerAnalyticsEvent = _a.triggerAnalyticsEvent;
    useEffect(function () {
        i18n.changeLanguage(config.lang);
    }, [config.lang]);
    return (_jsx(Providers, __assign({ config: config, isRegistered: isRegistered, helpNumber: helpNumber, triggerAnalyticsEvent: triggerAnalyticsEvent, featureFlags: featureFlags, selectedAccountId: selectedAccountId }, { children: _jsx(I18nextProvider, __assign({ i18n: i18n }, { children: _jsx(AccountDetailsModal, { handleClose: handleClose, isModalOpen: isModalOpen, containerId: containerId }) })) })));
};
export default AccountDetailsRoot;
//# sourceMappingURL=index.js.map